import { createFormHook, createFormHookContexts } from '@tanstack/react-form';

type LoanCommentCategoryOption = {
  key: number;
  value?: string;
};

type CommentFormData = {
  category: LoanCommentCategoryOption;
  comment: string;
};

const { fieldContext, formContext } = createFormHookContexts();

const { useAppForm, withForm } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {},
  formComponents: {},
});

export { useAppForm, withForm };
export { useStore } from '@tanstack/react-form';
export type { CommentFormData, LoanCommentCategoryOption };
